if (!customElements.get('pdp-one-time-purchase')) {
  customElements.define(
    'pdp-one-time-purchase',
    class PDPOneTimePurchase extends HTMLElement {
      connectedCallback() {
        this.bindEvents();
        this.setup();
      }

      setup() {
        if (this.closest('product-info')?.dataset.pdpUpdating === 'true') return;
        this.productInfo = this.closest('product-info');
        this.formId = this.dataset.formId;
        this.form =
          (this.formId ? document.getElementById(this.formId) : null) ||
          this.productInfo?.querySelector('form[is="product-form"]') ||
          null;

        this.buyOnceButton = this.querySelector('.pdp-one-time-purchase__button');

        const hasSellingPlansSelected = !!this.productInfo?.querySelector('.pdp-selling-plans__input:checked');
        if (this.productInfo?.dataset?.pdpPurchaseMode === 'one-time' || !hasSellingPlansSelected) {
          this.buyOnceButton?.classList.add('is-selected');
          if (this.productInfo && this.productInfo.dataset.pdpPurchaseMode !== 'subscription') {
            this.productInfo.dataset.pdpPurchaseMode = 'one-time';
          }
        }
      }

      bindEvents() {
        if (this.dataset.bound === 'true') return;
        this.addEventListener('click', async (event) => {
          const trigger = event.target.closest('.pdp-one-time-purchase__button');
          if (!trigger) return;

          event.preventDefault();
          this.setup();
          this.selectOneTimePurchase();
        });
        this.dataset.bound = 'true';
      }

      selectOneTimePurchase() {
        if (this.form) {
          const planInput = this.form.querySelector('input[name="selling_plan"]');
          if (planInput) {
            planInput.value = '';
          }
        }

        this.buyOnceButton?.classList.add('is-selected');
        this.productInfo?.querySelectorAll('.pdp-selling-plans__input').forEach((input) => {
          input.checked = false;
        });
        this.productInfo?.querySelectorAll('.pdp-selling-plans__option').forEach((option) => {
          option.classList.remove('is-selected');
        });
        if (this.productInfo) {
          this.productInfo.dataset.pdpPurchaseMode = 'one-time';
          this.productInfo.dispatchEvent(
            new CustomEvent('pdp:purchase-mode-changed', {
              bubbles: true,
            })
          );
        }
      }
    }
  );
}
